import { ProgramEntity } from '@/modules/programs/domain/entities/ProgramEntity';
import { Program } from '@/types';
import { requestQuery } from '@/services/request';
import { corePopularPrograms } from '@/modules/search/domain/routes/searchRoutes';

export const getPopularPrograms = async () => {
  try {
    const response = await requestQuery<Program[]>({
      url: corePopularPrograms,
    });

    return (response || []).map((d) => new ProgramEntity(d));
  } catch (e) {
    return null;
  }
};
